import { useState, useEffect, useMemo } from "react";

/**
 * Hook to track the age of exchange rate data
 * Provides real-time updates on how stale the rate is
 *
 * @param fetchedAt - Timestamp when rate was last fetched
 * @returns Object with ageSeconds and status (fresh/aging/stale)
 */
export function useRateAge(fetchedAt: Date | null) {
  const [ageSeconds, setAgeSeconds] = useState(0);

  useEffect(() => {
    if (!fetchedAt) return;

    // Update age every second
    const interval = setInterval(() => {
      const now = new Date();
      const diff = Math.floor((now.getTime() - fetchedAt.getTime()) / 1000);
      setAgeSeconds(diff);
    }, 1000);

    return () => clearInterval(interval);
  }, [fetchedAt]);

  // Determine freshness status based on age thresholds
  const status = useMemo(() => {
    if (ageSeconds < 900) return "fresh";
    if (ageSeconds < 1800) return "aging";
    return "stale";
  }, [ageSeconds]);

  return { ageSeconds, status };
}
